import React from 'react'
import { Form, Input, Typography, Card } from 'antd'
import { useCompanyStore } from '../../store/company/companyStore'
import { CompanyLogo } from '../../components/Header/CompanyLogo'
import { useApi } from '../../services/ApiContext'

const { Title, Text } = Typography

export const CompanySettings: React.FC = () => {
  const company = useCompanyStore((state) => state.company)
  const api = useApi()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateCompany = (values: any) => {
    values.settings = {
      ...company.settings,
      taxNumber: values.taxNumber
    }
    api.syncCompany(values)
  }

  return (
    <div className="space-y-6">
      <Card>
        <Title level={5}>Company Logo</Title>
        <Text type="secondary" className="block mb-4">
          Your logo will appear on all documents and purchase orders
        </Text>

        <Form
          layout="vertical"
          initialValues={{ ...company, taxNumber: company.settings.taxNumber }}
          onValuesChange={(_, values) => updateCompany(values)}
        >
          <Form.Item label="Logo">
            <CompanyLogo />
          </Form.Item>

          <Form.Item name="name" label="Company Name">
            <Input autoComplete="off" placeholder="Enter your company name" />
          </Form.Item>

          <Form.Item name="address" label="Address">
            <Input.TextArea placeholder="Enter your company address" rows={3} />
          </Form.Item>

          <Form.Item name="phone" label="Phone">
            <Input placeholder="Enter your phone number" />
          </Form.Item>

          <Form.Item name="email" label="Email">
            <Input placeholder="Enter your email address" />
          </Form.Item>

          <Form.Item name="taxNumber" label="Tax/GST Number">
            <Input placeholder="Enter your tax/GST number" />
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}
